import * as methods from './methods'
import * as maco from './maco'
import * as leurisExport from './leurisExport'

export default {
  methods,
  maco,
  leurisExport
}



// WEBPACK FOOTER //
// ./src/api/index.js